module.exports = __webpack_public_path__ + "img/Afghanistan.fe22c70b.png";